import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearRightDoorInteriorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearRightDoorInterior(props: RearRightDoorInteriorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Right Door"
      width={318}
      height={72}
      viewBox="0 0 318 72"
      position={{top: -5, right: 321}}
    >
      <path
        d="M257 6C284 6 317 17 317 35C317 37 316.333 39.097 316 39.8955H287L206.928 39.6064L200.915 39.585L39 39L15 39.3047C15.3333 37.1914 15 31.2329 11 24.3047C7 17.3765 3.33333 9.11325 2 6H257Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M39 39.0002H15C15.3333 36.887 15 31.2329 11 24.3047C7 17.3765 3.33333 9.11325 2 6H257C284 6 317 17 317 35C317 36.7486 316.634 38.4113 315.937 40L39 39.0002Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M13 27.6087C120.201 28.8042 226.843 28.2808 316 29.6956"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224 16C238.937 15.9997 258.853 14 256.861 11C250.119 0.843768 231.966 1 224 1C216.034 1 197.881 0.84377 191.139 11C189.147 14 209.062 15.9997 224 16ZM207 10C208.766 7.75684 211.491 6.00004 216 6H232C236.509 6.00005 239.234 7.75682 241 10H207Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M256.862 11C250.119 0.843672 231.966 1.00014 224 1.00014C216.034 1.00014 197.881 0.843672 191.138 11C189.147 14 209.062 15.9997 224 16C238.937 15.9997 258.853 14 256.862 11Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M243 15C242.667 12.3333 240 6 232 6C224 6 224 6 224 6C224 6 224 6 216 6C208 6 205.333 12.3333 205 15"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M207 10H241"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M177 71C185.23 71 191.117 68.9079 195 65.833V66H257C262 66 287 66 287 54H306C310 54 311 52 316 40L39 39H15V54H39C39 69.9433 42 71 51 71H177Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M39 54C39 69.9433 42 71 51 71H177C194 71 201 62.0723 201 54"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M195 66H257C262 66 287 66 287 54"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="181"
        y="59.0001"
        width="7"
        height="7"
        rx="3.5"
        transform="rotate(90 181 59.0001)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="170"
        y="61"
        width="3"
        height="8"
        rx="1.5"
        transform="rotate(90 170 61)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="49"
        y="43"
        width="7"
        height="7"
        rx="3.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M15 54V39L39 39.0002L316 40C311 52 310 54 306 54H15Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
